module.exports = __webpack_public_path__ + "static/media/S (120).dc657b43.jpg";